import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyleSheet } from 'hoc/styles';
import { Div } from 'components/Div';
import { Icon } from 'components/Icon';
import { styleSheet } from './stylesheet';

class SortHandle extends PureComponent {
    static propTypes = {
        styles: PropTypes.objectOf(PropTypes.object).isRequired,
        passedStyles: PropTypes.objectOf(PropTypes.any),
        color: PropTypes.string
    };

    static defaultProps = {
        passedStyles: {},
        color: '#000000'
    };

    render() {
        const { styles, passedStyles, color } = this.props;
        return (
            <Div className="sortHandle" styles={{ ...styles.container, ...passedStyles }}>
                <Icon type="dragHandle" color={color} />
            </Div>
        );
    }
}

export const SortHandleUI = compose(withStyleSheet(styleSheet))(SortHandle);
